import React, { forwardRef } from 'react';
import { FaSearch } from 'react-icons/fa';

import { Botao, Container, Input } from './styles';

interface IProps extends React.InputHTMLAttributes<HTMLInputElement> {
  onPesquisar: () => void;
}

// Input de busca livre (?pesquisa=) com botão de lupa. Enter também pesquisa.
const CampoPesquisa = forwardRef<HTMLInputElement, IProps>(({ onPesquisar, ...rest }, ref) => {
  function handleSubmit(e: React.FormEvent<HTMLFormElement>) {
    e.preventDefault();
    onPesquisar();
  }

  return (
    <Container onSubmit={handleSubmit} role='search'>
      <Input ref={ref} type='search' autoComplete='off' {...rest} />
      <Botao type='submit' aria-label='Pesquisar'>
        <FaSearch size={15} />
      </Botao>
    </Container>
  );
});

export default CampoPesquisa;
